/**
 * Error codes carried in the API error envelope: { error: { code, message } }.
 * The envelope shape matches what the frontend's getErrorMessage()/getErrorCode()
 * utilities (copied from the reference project) already read.
 */
export const ErrorCodes = {
  AuthInvalidSession: "Auth:InvalidSession",
  AuthUnauthorized: "Auth:Unauthorized",
  CommonNotFound: "Common:NotFound",
  CommonValidation: "Common:ValidationError",
  WabaWindowClosed: "Waba:WindowClosed",
  WabaTemplateNotApproved: "Waba:TemplateNotApproved",
  WabaTemplateNotAllowed: "Waba:TemplateNotAllowed",
  WabaInvalidPhoneNumber: "Waba:InvalidPhoneNumber",
  WabaCannotMessageSelf: "Waba:CannotMessageSelf",
  WabaClientBusyWithOtherDriver: "Waba:ClientBusyWithOtherDriver",
  WabaClientHasActiveConversation: "Waba:ClientHasActiveConversation",
  WabaSendFailed: "Waba:SendFailed",
  DeliveryStatusLocked: "Delivery:StatusLocked",
  CreditsInsufficient: "Credits:Insufficient",
  CreditsExpired: "Credits:Expired",
  BillingPlanNotFound: "Billing:PlanNotFound",
  BillingPaymentFailed: "Billing:PaymentFailed",
  BillingGatewayUnavailable: "Billing:GatewayUnavailable",
  LabelsNotConfigured: "Labels:NotConfigured",
  LabelsExtractFailed: "Labels:ExtractFailed",
  PushNotConfigured: "Push:NotConfigured",
  PushSendFailed: "Push:SendFailed",
} as const;

export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];

export interface ApiErrorEnvelope {
  error: {
    code: string;
    message: string;
    details?: string;
    validationErrors?: { message: string; members?: string[] }[] | null;
  };
}
